// Gallery dimensions
export const GALLERY_DIMENSIONS = {
    width: 35,
    depth: 25,
    height: 6,
};

// Camera settings
export const CAMERA_SETTINGS = {
    height: 2.0,
    defaultFOV: 60,
    minFOV: 30,
    maxFOV: 120,
};

// Lighting settings
export const LIGHTING = {
    ambient: {
        intensity: 0.4,
        color: "#ffffff"
    },
    pointLight: {
        intensity: 0.35,
        color: "#ffffff"
    },
    wallWash: {
        intensity: 0.15,
        color: "#ffffff"
    }
};

// UI text
export const UI_TEXT = {
    clickToExplore: "Click to explore",
    releaseMousePrompt: "Press C to release mouse",
    editMode: "Edit Mode - Click to place assets (V to view)",
    showMode: "View Mode - Gallery presentation (V to edit)"
};

// Key bindings
export const KEY_BINDINGS = {
    toggleView: "KeyV",
    releaseMouse: "KeyC",
    escape: "Escape"
}; 